import { render } from "./DrawSignature.vue.ts?vue&type=template&id=9579175c&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./DrawSignature.vue?vue&type=template&id=9579175c&scoped=true&ts=true"
import script from "./DrawSignature.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./DrawSignature.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawSignature.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./DrawSignature.vue?vue&type=script&setup=true&lang=ts"

import "./DrawSignature.vue.scss?vue&type=style&index=0&id=9579175c&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./DrawSignature.vue?vue&type=style&index=0&id=9579175c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9579175c"],['__file',"src/apps/merchant3/shared-components/common/DrawSignature.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9579175c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9579175c', __exports__)) {
    api.reload('9579175c', __exports__)
  }
  
  module.hot.accept("./DrawSignature.vue.ts?vue&type=template&id=9579175c&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./DrawSignature.vue?vue&type=template&id=9579175c&scoped=true&ts=true", () => {
    api.rerender('9579175c', render)
  })

}


export default __exports__